import { useEffect, useMemo } from "react";

import { useAtom, useSetAtom } from "jotai";

import {
    // checkoutAtom,
    createUserCheckoutStateMutation,
    userCheckoutStateTokenAtom
} from "@atoms/checkoutAtom";

// import { dispatchHSEvents } from "@utils/dispatchHSEevents";

const usePostCheckoutState = (onSuccess?: () => void) => {
    const setUserCheckoutStateToken = useSetAtom(userCheckoutStateTokenAtom);
    // const [checkout] = useAtom(checkoutAtom);

    const userCheckoutStateApiAtom = useMemo(() => {
        const [, atom] = createUserCheckoutStateMutation();
        return atom;
    }, []);

    const [checkoutStateApiData, checkoutStateApiMutate] = useAtom(
        userCheckoutStateApiAtom
    );
    const checkoutStateMutate = () => checkoutStateApiMutate([{}]);
    useEffect(() => {
        if (checkoutStateApiData.isSuccess) {
            if (typeof onSuccess === "function") onSuccess();
            const {
                data: { token }
            } = checkoutStateApiData.data;
            setUserCheckoutStateToken(token);
            // dispatchHSEvents("trackCustomBehavioralEvent", undefined, {
            //     checkout_status: "INIT",
            //     checkout_token: token,
            //     email: checkout.user.email
            // });
        }
    }, [checkoutStateApiData]);

    return {
        checkoutStateMutationState: {
            isPending: checkoutStateApiData.isPending,
            isSuccess: checkoutStateApiData.isSuccess
        },
        checkoutStateMutate
    };
};

export default usePostCheckoutState;
